import api from './api';

export const systemAPI = {
    getSystemConfig: async () => {
        const response = await api.get('/system-config');
        return response.data;
    },

    updateSystemConfig: async (data) => {
        const response = await api.put('/system-config', data);
        return response.data;
    },

    // Scraping config
    getScrapingConfig: async () => {
        const response = await api.get('/system-config/scraping');
        return response.data;
    },

    updateScrapingConfig: async (data) => {
        const response = await api.put('/system-config/scraping', data);
        return response.data;
    },

    runScrapingSpeedTest: async (levels = [1, 2]) => {
        const response = await api.post('/system-config/scraping/speed-test', { levels });
        return response.data;
    },

    // Scheduler
    getSchedulerStatus: async () => {
        const response = await api.get('/system-config/scheduler/status');
        return response.data;
    },

    runScheduler: async () => {
        const response = await api.post('/system-config/scheduler/run');
        return response.data;
    },

    updateSchedulerConfig: async (data) => {
        const response = await api.put('/system-config/scheduler', data);
        return response.data;
    },

    resetSchedulerStats: async () => {
        const response = await api.post('/system-config/scheduler/reset-stats');
        return response.data;
    }
};

export default systemAPI;
